/**
 *  View more/less functionality
 *
 */
const init = () => {
    document.querySelectorAll(".help-questions--toggle-wrapper").forEach($wrapper => {
        $wrapper.addEventListener("click", e => {
            const $targetWrapper = e.currentTarget;
            const $targetToggleActive = $targetWrapper.querySelector(".help-question--toggle.active");
            const $targetToggleHidden = $targetWrapper.querySelector(".help-question--toggle.d-none");

            $targetToggleActive.classList.remove("active");
            $targetToggleActive.classList.add("d-none");

            $targetToggleHidden.classList.remove("d-none");
            $targetToggleHidden.classList.add("active");

            $targetWrapper.parentNode.querySelector(".help-questions--extra").classList.toggle("d-none");
        });
    });
};

export { init };
